import { render, staticRenderFns } from "./GiftIcon.vue?vue&type=template&id=683f4509&scoped=true&"
import script from "./GiftIcon.vue?vue&type=script&lang=js&"
export * from "./GiftIcon.vue?vue&type=script&lang=js&"
import style0 from "./GiftIcon.vue?vue&type=style&index=0&id=683f4509&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f4509",
  null
  
)

export default component.exports